"use client";

import * as X from "@/ui";
import type { Article } from "@/providers/strapi";
import { calculateReadingTime } from "./util";
import { ArticleCover } from "./ArticleCover";
import ReactMarkdown from "react-markdown";


export function ArticleCard(props: X.PageProps<{
  article: Article;
  className?: string;
  large?: boolean;
}>) {
  // const tr = X.useTranslator();

  const [date, setDate] = X.useState(new Date(props.article.date).toLocaleDateString());
  X.useMountEffect(() => {
    const formatter = new Intl.DateTimeFormat(props.locale, {
      dateStyle: "medium",
    });

    setDate(formatter.format(new Date(props.article.date)));
  });

  return (
    <X.Link
      href={{ pathname: "/blog/[articleSlug]", params: { articleSlug: props.article.slug } }}
      className={X.clsx("group block", props.className)}
    >
      <div className={X.clsx(
        "flex rounded-lg overflow-hidden",
        //"hover:shadow-md transition-shadow duration-200",
        props.large ? "flex-col" : "flex-row xl:flex-col"
      )}>
        <div className={X.clsx(
          "relative rounded-lg flex-shrink-0 overflow-hidden",
          props.large
            ? "h-[225px] w-full"
            : "w-[98px] h-[98px] xl:w-full xl:h-[184px]"
        )}>
          <ArticleCover
            article={props.article}
            className="object-cover group-hover:scale-105 transition-transform duration-300"
            fill
            size={props.large ? "large" : "medium"}
            sizes={props.large
              ? "(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 60vw"
              : "(max-width: 640px) 50vw, (max-width: 1024px) 30vw, 20vw"
            }
          />
        </div>

        <div className={X.clsx(
          "xl:py-4 group-hover:text-black/70",
          props.large ? "pt-4" : "pl-4 xl:pl-0"
        )}>
          <div className="text-[12px] xl:text-[14px] mb-2">
            {props.article.category.name}
          </div>
          <h3 className={X.clsx("xl:text-[24px] mb-2 leading-tight", props.large ? "text-[20px] font-medium" : "text-[16px] font-semibold xl:font-medium")}>
            {/* {props.article.titleH1} */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <>{props.children}</>,
              h1: ({ ...props }) => <>{props.children}</>,
              h2: ({ ...props }) => <>{props.children}</>,
              h3: ({ ...props }) => <>{props.children}</>,
              h4: ({ ...props }) => <>{props.children}</>,
              h5: ({ ...props }) => <>{props.children}</>,
            }}>
              {props.article.titleH1}
            </ReactMarkdown>
          </h3>

          <div className="flex items-center text-[10px] space-x-1">
            <div className="flex items-center">
              <X.Icon.Clock className="w-3 h-3 mr-1" />
              <span>
                {calculateReadingTime(props.article)}
                {" "}
                {/* {tr({ en: "min. reading", fr: "min. lecture" })} */}
                {/* min. reading */}
                {props.article.readingTimeLabel}
              </span>
            </div>
            <div>-</div>
            <div className="flex items-center">
              <span>{date}</span>
            </div>
          </div>
        </div>
      </div>
    </X.Link>
  );
}
